import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { createContext, useEffect, useRef, useState } from "react";
import config from "@/lib/config";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var RecaptchaV3Context = /*#__PURE__*/createContext();
RecaptchaV3Context.displayName = "RecaptchaV3Context";
export function RecaptchaV3Provider(_ref) {
  var children = _ref.children;

  var _useState = useState(false),
      recaptchaV3Badge = _useState[0],
      setRecaptchaV3Badge = _useState[1];

  var recaptchaV3BadgeRef = useRef(null);

  var showRecaptchaV3Badge = function showRecaptchaV3Badge() {
    setRecaptchaV3Badge(true);
  };

  var hideRecaptchaV3Badge = function hideRecaptchaV3Badge() {
    setRecaptchaV3Badge(false);
  };

  var contextValue = {
    recaptchaV3Badge: recaptchaV3Badge,
    showRecaptchaV3Badge: showRecaptchaV3Badge,
    hideRecaptchaV3Badge: hideRecaptchaV3Badge
  };
  useEffect(function () {
    if (recaptchaV3Badge) {
      recaptchaV3BadgeRef.current.style.visibility = "visible";
      recaptchaV3BadgeRef.current.style.position = "relative";
      recaptchaV3BadgeRef.current.style.zIndex = "9999";
    } else {
      recaptchaV3BadgeRef.current.style.visibility = "hidden";
    }
  }, [recaptchaV3Badge]);
  return /*#__PURE__*/_jsxs(RecaptchaV3Context.Provider, {
    value: contextValue,
    children: [/*#__PURE__*/_jsx("div", {
      id: "recaptchaV3Badge",
      ref: recaptchaV3BadgeRef
    }), /*#__PURE__*/_jsx(GoogleReCaptchaProvider, {
      reCaptchaKey: config.reCAPTCHASiteKey.v3,
      language: "ja",
      useEnterprise: true,
      container: {
        element: "recaptchaV3Badge",
        parameters: {
          badge: "bottomright",
          theme: "light"
        }
      },
      children: children
    })]
  });
}